// extracted by mini-css-extract-plugin
module.exports = {"container":"Login_container__S4JBA","form-container":"Login_form-container__2bdyi","signup-forgot":"Login_signup-forgot__24kpm"};